import $ from 'jquery'

export default function csrfToken() {
  return $('meta[name="csrf-token"]').attr('content')
}
